<template>
  <div class="section">
    <div class="container">
      <div class="content">
        <!-- title -->
        <div class="menu-label is-size-6" >
          <div v-if="!isEmpty">
            <div v-if="isTransaction">
              <span class="fa fa-paper-plane"></span>
              <span>TRANSACTION</span>
              <span class="has-text-info" @click="isShowingQR = !isShowingQR">
                <i class="fa fa-qrcode"></i>
              </span>
            </div>
            <div v-else>
              <span class="fa fa-file-text"></span>
              <!-- invocation -->
              <span v-if="isInvoke">{{ contractAddr }}</span>
              <!-- contract deploy -->
              <span v-else>{{ $t("table.contract_creation") }}</span>
              <span class="has-text-info" @click="isShowingQR = !isShowingQR">
                <i class="fa fa-qrcode"></i>
              </span>
            </div>
            <!-- qr code -->
            <b-collapse :open.sync="isShowingQR">
              <div class="content">
                <QRCode :value="qrAddress"
                    :options="{ size: 160 }"></QRCode>
              </div>
            </b-collapse>
          </div>
        </div>
        <!-- hash -->
        <code class="is-size-5 has-text-weight-bold">
          {{ $route.params.hash }}
        </code>

        <!-- error -->
        <div class="notification is-warning" v-if="isEmpty">
          无法找到指定的交易记录
        </div>
        <p></p>
        <div class="columns">
          <!-- TABLE -->
          <div class="column">
            <table class="table" v-if="!isEmpty">
              <tbody>
              <tr>
                <td>{{ $t("table.from") }}</td>
                <td>
                  <a v-bind:href="'#/account/' + tx.from">
                    <code class="has-text-info">{{ tx.from }}</code>
                  </a>
                </td>
              </tr>
              <!-- contract deploy -->
              <tr v-if="isDeploy">
                <td>{{ $t("table.contract_address") }}</td>
                <td>
                  <a v-bind:href="'#/contract/' + receipt.contractAddress">
                    <code class="has-text-info">{{ receipt.contractAddress }}</code>
                  </a>
                  <span v-if="status === 1">
                    <b-icon pack="fa" icon="check-circle" type="is-success" size="is-small"></b-icon>
                  </span>
                  <span v-if="status !== 1">
                    <b-icon pack="fa" icon="times-circle" type="is-danger" size="is-small"></b-icon>
                  </span>
                </td>
              </tr>
              <!-- contract invocation -->
              <tr v-else-if="isInvoke">
                <td>{{ $t("table.to") }}</td>
                <td>
                  <a v-bind:href="'#/contract/' + tx.to">
                    <code class="has-text-info">{{ tx.to }}</code>
                  </a>
                  <span v-if="status === 1">
                    <b-icon pack="fa" icon="check-circle" type="is-success" size="is-small"></b-icon>
                  </span>
                  <span v-if="status !== 1">
                    <b-icon pack="fa" icon="times-circle" type="is-danger" size="is-small"></b-icon>
                  </span>
                </td>
              </tr>
              <tr>
                <td>{{ $t("table.status") }}</td>
                <td>
                  <span v-if="!tx.pending">
                    {{ $t("table.mined") }}
                    <b-icon pack="fa" icon="check-circle" type="is-success" size="is-small"></b-icon>
                  </span>
                  <span v-if="tx.pending">
                    {{ $t("table.synchronizing") }}
                    <b-icon pack="fa" icon="spinner" type="is-info" custom-class="fa-pulse" size="is-small"></b-icon>
                  </span>
                </td>
              </tr>
              <!-- contract deploy -->
              <tr v-if="isDeploy">
                <td>{{ $t("table.contract_name") }}</td>
                <td>{{ extra.contract }}</td>
              </tr>
              <!-- contract invoke -->
              <tr v-if="isInvoke">
                <td>{{ $t("table.contract_name") }}</td>
                <td><code>{{ contractName }}</code></td>
              </tr>
              <tr v-if="isInvoke">
                <td>{{ $t("table.event") }}</td>
                <td><code>{{ methodName }}</code></td>
              </tr>
              <tr v-for="(value, key) in extra.arguments" :key="key">
                <td>{{ key }}</td>
                <td>
                  <a v-if="$utils.mayBeAddress(value)" v-bind:href="'#/contract/' + value">
                    <code class="has-text-info">{{ value }}</code>
                  </a>
                  <a v-else-if="$utils.mayBeHash(value)" v-bind:href="'#/tx/' + value">
                    <code class="has-text-info">{{ value }}</code>
                  </a>
                  <span v-else>{{ value }}</span>
                </td>
              </tr>
              <!-- normal transaction -->
              <tr v-if="isTransaction">
                <td>Value</td>
                <td>{{ $utils.formatAmount(tx.value) }}</td>
              </tr>
              <tr v-if="isTransaction">
                <td>Gas</td>
                <td>{{ tx.gas }}</td>
              </tr>
              <tr v-if="isTransaction">
                <td>Gas Used</td>
                <td>{{ parseInt(receipt.gasUsed) }}</td>
              </tr>
              <tr v-if="isTransaction">
                <td>Gas Price</td>
                <td>{{ tx.gas_price }}</td>
              </tr>
              <tr v-if="isTransaction">
                <td>ChainID</td>
                <td>{{ tx.chain_id }}</td>
              </tr>
              <tr v-if="isTransaction">
                <td>Nonce</td>
                <td>{{ tx.nonce }}</td>
              </tr>
              </tbody>
            </table>
            <!-- table end -->
          </div>
          <!-- EVENT -->
          <div class="column" v-if="extra.arguments">
            <ExtraEvent :extra="extra"></ExtraEvent>
          </div>
        </div>

        <!-- json -->
        <div v-if="!isEmpty">
          <h2>TRANSACTION JSON</h2>
          <blockquote>
            <code class="breakable">{{ txJson }}</code>
          </blockquote>
          <h2>RECEIPT JSON</h2>
          <blockquote>
            <code class="breakable">{{ receiptJson }}</code>
          </blockquote>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ExtraEvent from '../components/layout/ExtraEvent'
  import QRCode from '@xkeshi/vue-qrcode'
  import { mapState } from 'vuex'

  export default {
    name: 'Transaction',
    components: {ExtraEvent, QRCode},
    mounted () {
      this.$store.dispatch('loadTransaction', this.$route.params.hash.toLowerCase())
    },
    data () {
      return {
        isShowingQR: false
      }
    },
    computed: {
      ...mapState(['tx', 'receipt', 'extra', 'txJson', 'receiptJson']),
      isEmpty () {
        return this.$_.isEmpty(this.tx)
      },
      isInvoke () {
        return this.tx.what === 'contract_invoke'
      },
      isDeploy () {
        return this.tx.what === 'contract_creation'
      },
      isTransaction () {
        return this.tx.what === ''
      },
      status () {
        if (this.receipt && this.receipt.status) {
          return parseInt(this.receipt.status)
        } else {
          return 0
        }
      },
      contractAddr () {
        if (this.extra.contract) {
          return this.extra.contract
        } else {
          return 'CONTRACT INVOKE'
        }
      },
      contractName () {
        if (this.extra.contract) {
          return this.extra.contract
        } else {
          return 'N/A'
        }
      },
      methodName () {
        if (this.extra.method) {
          return this.extra.method
        } else {
          return 'N/A'
        }
      },
      qrAddress () {
        return window.location.protocol + '//' + window.location.host + '/#/tx/' + this.$route.params.hash
      }
    }
  }
</script>

<style lang="scss" scoped>
  blockquote {
    padding: 16px;
    border-left: none;
    margin: 0;
  }

  code.breakable {
    word-break: break-all;
    white-space: pre-wrap;
    padding: 0;
  }

  table {
    width: 100%;
  }

  td {
    white-space: normal;
  }

  td:first-child {
    width: 7rem;
  }

  code {
    word-break: keep-all;
  }

  .notification {
    margin-top: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/Transaction.vue